// @flow

import * as React from 'react';
import type { PosPreview } from './types';

type Props = {
  /** Data necessary to render POS preview */
  preview: PosPreview,
};

/** Contents for the preview, showing current POS */
const PosPreviewContents = ({ preview }: Props) => <div>{preview.country}</div>;

export default PosPreviewContents;
